

/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 *  TimeZoneIcon Icon
 * @author Anuja Gaikwad
 * @file TimeZoneIcon.jsx
 */

import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from '@mui/material';

function TimeZoneIcon({ sx, ...props }) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 18 18"
      sx={{
        width: 18,
        height: 18,
        fontSize: 18,
        ...sx
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0ZM9 12.25C8.40831 12.25 7.83674 12.2789 7.29185 12.3321C7.45542 13.217 7.68322 14.0177 7.96373 14.6909C8.42068 15.7875 8.87625 16.25 9 16.25C9.12375 16.25 9.57932 15.7875 10.0363 14.6909C10.3168 14.0177 10.5446 13.217 10.7082 12.3309C10.1633 12.2789 9.59169 12.25 9 12.25ZM12.4402 12.5875C12.2127 13.8421 11.8694 14.9482 11.4426 15.8283C12.6599 15.3928 13.7267 14.641 14.5442 13.6719L14.7433 13.4252L14.8272 13.3143C14.1984 13.0363 13.3857 12.7788 12.4402 12.5875ZM5.56027 12.5867C4.61429 12.7788 3.80163 13.0364 3.17321 13.3149C4.01994 14.4564 5.19412 15.3404 6.55672 15.8277C6.13028 14.9479 5.78719 13.842 5.56027 12.5867ZM2.31808 6.17972L2.23246 6.394C1.92083 7.20274 1.75 8.08142 1.75 9C1.75 10.0006 1.95268 10.9538 2.31808 11.8203C3.15282 11.4094 4.17673 11.0759 5.32914 10.8481C5.27727 10.2516 5.25 9.63344 5.25 9C5.25 8.3668 5.27725 7.74888 5.32877 7.15317C4.32073 6.95276 3.4108 6.67236 2.63986 6.33012L2.31808 6.17972ZM15.6818 6.17976C14.8471 6.59062 13.8233 6.92412 12.6709 7.15258C12.7228 7.74885 12.75 8.36679 12.75 9C12.75 9.63344 12.7227 10.2516 12.6713 10.8469C13.8233 11.0759 14.8471 11.4094 15.6808 11.8208C16.0473 10.9538 16.25 10.0006 16.25 9C16.25 7.99944 16.0473 7.04623 15.6818 6.17976ZM10.936 7.40608L10.6555 7.43248C10.1189 7.47682 9.56552 7.5 9 7.5C8.33509 7.5 7.68703 7.46795 7.06403 7.40608C7.02192 7.92334 7 8.45681 7 9C7 9.54319 7.02192 10.0767 7.06319 10.5929C7.68703 10.532 8.33509 10.5 9 10.5C9.66473 10.5 10.3126 10.532 10.936 10.5939C10.9781 10.0767 11 9.54319 11 9C11 8.63787 10.9903 8.28007 10.9713 7.9285L10.936 7.40608ZM9 1.75C8.87625 1.75 8.42068 2.21246 7.96373 3.30912C7.68322 3.98234 7.45542 4.78302 7.29177 5.66906C7.83674 5.7211 8.40831 5.75 9 5.75C9.59169 5.75 10.1633 5.7211 10.7081 5.66794C10.5446 4.78302 10.3168 3.98234 10.0363 3.30912C9.57932 2.21246 9.12375 1.75 9 1.75ZM11.4426 2.17175L11.6041 2.52394C11.9561 3.33945 12.2418 4.31875 12.4397 5.41333C13.3857 5.22121 14.1984 4.96365 14.8263 4.68458C14.04 3.62472 12.9714 2.78687 11.7317 2.28224L11.4426 2.17175ZM6.5569 2.17191L6.25165 2.28906C5.01897 2.79441 3.95639 3.62951 3.17375 4.68614C3.80248 4.96392 4.61478 5.22131 5.55987 5.4119C5.76207 4.29682 6.05563 3.29917 6.41788 2.47341L6.5569 2.17191Z"
        fill="#2E2E2E"
      />
    </SvgIcon>
  );
}

TimeZoneIcon.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func])
};

TimeZoneIcon.defaultProps = {
  sx: undefined
};

export default TimeZoneIcon;

